// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2uLuk","title":"Images45_title__2n-CJ","images":"Images45_images__1EJoc"};